import { render, staticRenderFns } from "./editTeamMeetingModal.vue?vue&type=template&id=96c8f74a&scoped=true&"
import script from "./editTeamMeetingModal.vue?vue&type=script&lang=js&"
export * from "./editTeamMeetingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c8f74a",
  null
  
)

export default component.exports